package core.dateformat.domain

enum class DateFormat(
    val format: String,
) {
    MONTH_DAY("MM/DD/YYYY"),
    DAY_MONTH("DD/MM/YYYY"),
}